import React, { Component } from "react";
import AddTitleBar from "../../../components/titleBar/add_titleBar";
import InsertYard from "./insert-yard";
import { translate } from "react-i18next";
import {TITLES} from './yardConstants'

class AddYard extends Component {
  constructor(props) {
    super(props);

    this.state = {
      title: "add_title",
      editData: {},
    };
  }

  componentDidMount() {
    if (this.props.location.state && this.props.location.state.title) {
      this.setState({
        title: this.props.location.state.title,
        editData: { ...this.props.location.state },
      });
    }
  }

  onFormSubmit = () => {
    this.props.history.push("/yard");
    this.props.history.go();
  };
  render() {
    return (
      <React.Fragment>
        <AddTitleBar Title={this.state.title === 'add_title' ? (TITLES.add_title||'Add Yard') : (TITLES.edit_title||'Edit Yard')} LinkName="/yard" />
        <div className="m-2">
          <InsertYard
            editData={this.state.editData}
            onFormSubmit={this.onFormSubmit}
          />
        </div>
      </React.Fragment>
    );
  }
}
export default AddYard;
